import { render, staticRenderFns } from "./admin-stock.vue?vue&type=template&id=0ef0e6d9&scoped=true"
import script from "./admin-stock.vue?vue&type=script&lang=js"
export * from "./admin-stock.vue?vue&type=script&lang=js"
import style0 from "./admin-stock.vue?vue&type=style&index=0&id=0ef0e6d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef0e6d9",
  null
  
)

export default component.exports